export const CONTENT_TYPES = {
  IMAGE: 'IMAGE',
  TEXT: 'TEXT',
  VIDEO: 'VIDEO',
}

export const CONTENT_CATEGORIES = {
  SOCIAL_MEDIA: 'SOCIAL_MEDIA',
  BLOG: 'BLOG',
  ASSISTANT: 'ASSISTANT',
}


export const PRIORITY_LEVELS = [1, 2, 3, 4, 5]

export const getContentTypeLabel = (type) => {
  const labels = {
    [CONTENT_TYPES.IMAGE]: 'Görsel',
    [CONTENT_TYPES.TEXT]: 'Metin',
    [CONTENT_TYPES.VIDEO]: 'Video',
  }
  return labels[type] || type
}

export const getContentCategoryLabel = (category) => {
  const labels = {
    [CONTENT_CATEGORIES.SOCIAL_MEDIA]: 'Sosyal Medya',
    [CONTENT_CATEGORIES.BLOG]: 'Blog',
    [CONTENT_CATEGORIES.ASSISTANT]: 'Asistan',
  }
  return labels[category] || category
}


export const getPriorityLabel = (priority) => {
  const labels = {
    1: 'Çok Düşük',
    2: 'Düşük',
    3: 'Orta',
    4: 'Yüksek',
    5: 'Çok Yüksek',
  }
  return labels[priority] || priority
}


export const getContentTypeIcon = (type) => {
  const icons = {
    [CONTENT_TYPES.IMAGE]: 'image',
    [CONTENT_TYPES.TEXT]: 'text_format',
    [CONTENT_TYPES.VIDEO]: 'videocam',
  }
  return icons[type] || 'help'
}

export const getContentTypeIconClass = (type) => {
  const classes = {
    [CONTENT_TYPES.IMAGE]: 'text-purple-500',
    [CONTENT_TYPES.TEXT]: 'text-blue-500',
    [CONTENT_TYPES.VIDEO]: 'text-red-500',
  }
  return classes[type] || 'text-gray-500'
}

export const getPriorityBarClass = (priority) => {
  const classes = {
    1: 'bg-gray-400',
    2: 'bg-blue-400',
    3: 'bg-yellow-400',
    4: 'bg-orange-400',
    5: 'bg-red-400',
  }
  return classes[priority] || 'bg-gray-400'
}
